module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 14
// module chunks = 15 16